import { PayableRow } from "@wingspanhq/wingspan-api-sdk";

export type OffCyclePayrollTotals = {
  count: number;
  amount: number;
};

/**
 * Count and summed amount of the payables a run will pay.
 *
 * Computed over the rows rather than read off the search summary: the summary
 * covers the server-side filter, which cannot express either narrowing
 * `selectorOffCyclePayrollPayables` applies, so it would overstate both.
 */
export const selectorOffCyclePayrollTotals = (
  payables: PayableRow[]
): OffCyclePayrollTotals => ({
  count: payables.length,
  amount: payables.reduce((total, payable) => total + (payable.amount ?? 0), 0)
});
